import { useState } from 'react';
import type { Id } from '../../convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: hooks in src/hooks/ require two levels up to reach convex/_generated/

export function useAssignmentDialog() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedPolicyId, setSelectedPolicyId] = useState<string>('');
  const [confirmUnassignId, setConfirmUnassignId] = useState<Id<'policyBenefitPlanAssignments'> | null>(null);
  const [isAssigning, setIsAssigning] = useState(false);

  function openDialog() {
    setDialogOpen(true);
  }

  function closeDialog() {
    setDialogOpen(false);
    setSelectedPolicyId('');
  }

  function requestUnassign(id: Id<'policyBenefitPlanAssignments'>) {
    setConfirmUnassignId(id);
  }

  function cancelUnassign() {
    setConfirmUnassignId(null);
  }

  return {
    dialogOpen,
    openDialog,
    closeDialog,
    selectedPolicyId,
    setSelectedPolicyId,
    confirmUnassignId,
    requestUnassign,
    cancelUnassign,
    isAssigning,
    setIsAssigning,
  };
}
